import {Subject, takeUntil} from "rxjs";
import {Directive, OnDestroy} from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {TitleProviderObserverService} from "@shared/services/ui/title-provider-observer/title-provider-observer.service";

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'router-outlet',
  standalone: false
})
export class BrowserTabTitleActivatedRouteComponentsDirective implements OnDestroy {

  private readonly ngUnsubscribe = new Subject<void>();

  constructor(routerOutlet: RouterOutlet, titleProviderObserver: TitleProviderObserverService) {
    routerOutlet.activateEvents.pipe(takeUntil(this.ngUnsubscribe)).subscribe(component => {
      titleProviderObserver.setComponent(component);
    });
  }

  ngOnDestroy () {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
